import React from 'react';
import { getNumberOfCols, iconCategoryCssClass, iconSportCssClass } from '../../data/utils';
import { getLabel } from '../../InitData';
import TopMatchOdd from './TopMatchOdd';
import StatsToggle from '../../common/StatsToggle';
import PrematchContext from '../../contexts/PrematchContext';

function TopMatchPanel(props) {
    const prematchContext = React.useContext(PrematchContext);

    return (
        <div className="tab-pane fade show active" id="scheda-top-match-1" role="tabpanel">
            <div className="titolo-blocco-sport last-minute-t bg-nero bianco">
                <p className="nome-partita-sport">{getLabel('prematch_page.widget.top_match')}</p>
            </div>
            <div className="blocco-quote-espanse">
                {props.data?.map((m, i) => {
                    function handleClick() {
                        const tournamentUniqueId = `${m.sportRef}_${m.categoryRef}_${m.tournamentRef}`;
                        prematchContext.openEvent(tournamentUniqueId, m);
                    }

                    return (
                        <div key={i} className="scheda-giocata-sport bg-bianco nero padding-verticale padding-orizzontale bordo-tondo">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="tempo-torneo-top-match">{m.date}</div>
                                <div className="altre-top-match">
                                    <StatsToggle className="fas fa-signal stat-sel pointer" match={m} />
                                </div>
                            </div>
                            <div className="titolo-partita-top-match d-flex justify-content-between align-intems-center">
                                <div className="icone-torneo-top-match">
                                    <div className={`icona-sport img-fluid ico-sport ${iconSportCssClass(m.sportRef, m.sportIcon)}`}></div>
                                </div>
                                <span className="grigio grassetto">{m.tournamentDesc}</span>
                                <div className={`icone-torneo-top-match img-fluid altre-top-match img-flags ico-cat ${iconCategoryCssClass(m.sportRef, m.categoryRef, m.categoryIcon)}`}></div>
                            </div>
                            <div className="titolo-partita-top-match d-flex justify-content-center pointer" onClick={handleClick}>
                                <p className="titolo-partita-top-match-squadra text-right">{m.team1}</p>
                                <p className="titolo-partita-top-match-separatore">vs</p>
                                <p className="titolo-partita-top-match-squadra text-left">{m.team2}</p>
                            </div>
                            <div className={`lista-quote colonne-${getNumberOfCols(m.scommessa.odds)}`}>
                                {m.scommessa.odds.map(function(odd) {
                                    const id = `${m.id}_${odd.id}`;
                                    return <TopMatchOdd key={id} htmlId={id} {...odd} />
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default TopMatchPanel;
